<template>
  <agenda :agenda-type-id="2" />
</template>

<script>
import agenda from '@/components/agendas/agenda'

export default {
  name: 'CourseSchedule',
  components: {
    agenda
  }
}
</script>
